export default "__VITE_ASSET__834b947e__"